import { render, staticRenderFns } from "./TheSlide.vue?vue&type=template&id=feb10e78&"
import script from "./TheSlide.vue?vue&type=script&lang=js&"
export * from "./TheSlide.vue?vue&type=script&lang=js&"
import style0 from "./TheSlide.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports